<template>
    <el-dialog
        title="查看订单"
        :visible.sync="dialogVisible"
        width="850px"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
        <div
            v-loading="loading"
            class="purchase-record-container"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255,255,255,0)"
        >
            <el-table
                :data="tableData"
                style="width: 100%"
                :header-cell-style="tableHeader"
                :row-style="rowStyle"
                max-height="600px"
            >
                <el-table-column prop="orderNumber" label="订单号" width="250" />
                <el-table-column prop="productName" label="套餐" width="160" />
                <el-table-column label="份数" width="60">
                    <template> 1 </template>
                </el-table-column>

                <el-table-column prop="version" label="数量(个)" width="80" />
                <el-table-column prop="gmtCreate" label="时间" />
                <el-table-column label="状态" width="90">
                    <template> 已支付 </template>
                </el-table-column>
            </el-table>
            <div class="mt10 tr">
                <el-pagination
                    background
                    :current-page="query.index"
                    :page-size="query.size"
                    layout="pager, total, jumper"
                    :total="query.total"
                    @current-change="handleCurrentChange"
                />
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'PurchaseRecord',
    data() {
        return {
            dialogVisible: false,
            tableHeader: {
                background: '#ebecf1',
                color: '#4c4b4b',
                fontSize: '12px',
                fontWeight: 'normal',
            }, // 表头样式
            rowStyle: {
                fontSize: '12px',
            },
            tableData: [],
            loading: false,
            query: {
                index: 1,
                size: 6,
                total: 0,
            },
        };
    },
    methods: {
        show() {
            this.dialogVisible = true;
            this.getData();
        },
        getData() {
            this.loading = true;
            this.$ajax
                .post('/api/tiktok/ForbiddenWordOrder/search', {
                    pageIndex: this.query.index,
                    pageSize: this.query.size,
                })
                .then((res) => {
                    this.loading = false;
                    if (!res.success) {
                        this.$message.warning(res.message);
                        return;
                    }
                    this.tableData = res.data;
                    this.query.total = res.totalCount;
                });
        },
        handleCurrentChange(index) {
            this.query.index = index;
            this.getData();
        },
    },
};
</script>
<style lang="scss" scoped>
.purchase-record-container {
}
</style>
